import { ThemeProvider as NextThemesProvider, useTheme } from "next-themes";
import { Moon, Sun } from "lucide-react";

import { Button } from "@/components/ui/button";

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <NextThemesProvider attribute="class" defaultTheme="system" enableSystem storageKey="lucky.theme">
      {children}
    </NextThemesProvider>
  );
}

/**
 * Sun/Moon swap button. next-themes gives us the current resolved theme
 * (system → light|dark), we flip between the two extremes on click.
 */
export function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const next = resolvedTheme === "dark" ? "light" : "dark";
  return (
    <Button
      variant="ghost"
      size="icon"
      className="rounded-xl border border-transparent bg-card/50 shadow-sm hover:border-border hover:bg-card"
      aria-label="Переключить тему"
      onClick={() => setTheme(next)}
    >
      <Sun className="h-4 w-4 dark:hidden" />
      <Moon className="hidden h-4 w-4 dark:block" />
    </Button>
  );
}
